// Defines how many buttons can fit on a row
export const ROW_BUTTONS_COUNT = 2;
